// extracted by mini-css-extract-plugin
export default {"text":"CostNettoTemplate_text__LVuVO","addText":"CostNettoTemplate_addText__2xyLL","icon":"CostNettoTemplate_icon__j9etK","iconWithValue":"CostNettoTemplate_iconWithValue__tV-ti"};